import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-dda6f978")
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 机灵树学苑 ")
_popScopeId()

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_ctx.visible)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: "content",
        to: `/college`
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: require('/src/assets/college/college.png')
          }, null, 8, _hoisted_1),
          _hoisted_2
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}